
<div *ngIf="isMobile; then mobileBlock else nonMobileBlock"></div>
<ng-template #mobileBlock>
  <div class="mobile">
    <div class="main-wrapper">
      <app-page-header></app-page-header>
      <div id="main-content">
        <div class="row">
          <router-outlet></router-outlet>
        </div>
      </div>
      <div id="bottomMenuBar">
          <app-menu-bar></app-menu-bar>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #nonMobileBlock>
  <app-nav-menu></app-nav-menu>
  <div class="main-wrapper">
    <div id="sidebar">
      <a *ngIf="canAddLead" routerLink="/lead/add">
        <img alt="New Lead" src="assets/img/action_bar/new_lead.png" />
        <div class="label" i18n>New Lead</div>
      </a>
      <a *ngIf="canAddCustomer" routerLink="/customer/add">
        <img alt="New Customer" src="assets/img/action_bar/new_customer.png" />
        <div class="label" i18n>New Customer</div>
      </a>
      <a *ngIf="canAddQuote" routerLink="/quote/add">
        <img alt="New Quote" src="assets/img/action_bar/new_quote.png" />
        <div class="label" i18n>New Quote</div>
      </a>
      <a *ngIf="!hideJobTools" routerLink="/calendar">
        <img alt="Calendar" src="assets/img/action_bar/calendar.png" />
        <div class="label" i18n>Calendar</div>
      </a>
      <a *ngIf="!isFieldTech" routerLink="/report">
        <img alt="Reports" src="assets/img/action_bar/reports.png" />
        <div class="label" i18n>Reports</div>
      </a>
      <a *ngIf="isDealerAdmin && !quoteOnly" routerLink="/export">
        <img alt="Exports" src="assets/img/action_bar/export.png" />
        <div class="label" i18n>Export Files</div>
      </a>
      <a routerLink="/support/Faqs">
        <img alt="Support" src="assets/img/action_bar/support.png" />
        <div class="label" i18n>Support</div>
      </a>
    </div>
    <div id="main-content">
      <div class="row">
        <router-outlet></router-outlet>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  <app-footer></app-footer>
</ng-template>
